import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "filelist", "submit"]

  connect() {
    this.files = new DataTransfer()
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-indigo-500", "bg-indigo-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-indigo-500", "bg-indigo-50")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-indigo-500", "bg-indigo-50")

    for (const file of event.dataTransfer.files) {
      if (file.name.match(/\.(md|mdx)$/i)) {
        this.files.items.add(file)
      }
    }

    this.inputTarget.files = this.files.files
    this.updateFileList()
  }

  browse() {
    this.inputTarget.click()
  }

  selected() {
    for (const file of this.inputTarget.files) {
      if (file.name.match(/\.(md|mdx)$/i)) {
        this.files.items.add(file)
      }
    }
    this.inputTarget.files = this.files.files
    this.updateFileList()
  }

  removeFile(event) {
    const index = parseInt(event.params.index)
    this.files.items.remove(index)
    this.inputTarget.files = this.files.files
    this.updateFileList()
  }

  updateFileList() {
    const files = this.files.files
    if (files.length === 0) {
      this.filelistTarget.innerHTML = ""
      this.submitTarget.classList.add("hidden")
      return
    }

    this.submitTarget.classList.remove("hidden")
    this.filelistTarget.innerHTML = Array.from(files).map((file, i) =>
      `<div class="flex items-center justify-between py-1 px-2 text-sm text-gray-700 bg-gray-50 rounded">
        <span>${file.name}</span>
        <button type="button" data-action="file-drop#removeFile" data-file-drop-index-param="${i}" class="text-gray-400 hover:text-red-500 ml-2">&times;</button>
      </div>`
    ).join("")
  }
}
